<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Unternehmensprofil</p>

      <h2 class="presentation-page__title">Wer wir sind</h2>

      <p class="presentation-page__text">
        Deutsches Installations- und Projektierungsunternehmen für Photovoltaik und BESS — seit zwei
        Jahrzehnten.
      </p>

      <div class="presentation-page__body presentation-page__body--split">
        <div class="presentation-page__column presentation-page__column--text">
          <ul class="presentation-page__list">
            <li v-for="listItem in listItems" :key="listItem">
              {{ listItem }}
            </li>
          </ul>
        </div>

        <div class="presentation-page__column presentation-page__column--stats">
          <div class="presentation-page__stat-cards">
            <article
              v-for="stat in stats"
              :key="stat.label"
              :class="[
                'presentation-page__stat-card',
                `presentation-page__stat-card--${stat.accent}`,
              ]"
            >
              <p class="presentation-page__stat-value">{{ stat.value }}</p>
              <p class="presentation-page__stat-label">{{ stat.label }}</p>
              <p class="presentation-page__stat-detail">{{ stat.detail }}</p>
            </article>
          </div>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage04',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      listItems: [
        'Deutsches Installations- und Projektierungsunternehmen für Photovoltaik und BESS',
        'Über 20 Jahre Erfahrung in Planung und Umsetzung',
        'Fokus auf Qualität, Sicherheit und Skalierbarkeit',
        'Eigene Montageteams, eigene Projektentwicklung, eigene O&M-Organisation',
        'Bankfähige Dokumentation und Reporting nach RAL, DIN und VDE',
      ],
      stats: [
        {
          accent: 'brand-primary',
          value: '20+',
          label: 'Jahre Erfahrung',
          detail: 'PV-Installation seit 2004',
        },
        {
          accent: 'brand-teal',
          value: '9.000+',
          label: 'Projekte realisiert',
          detail: 'Von Privat bis Multi-MW',
        },
        {
          accent: 'brand-primary',
          value: '100%',
          label: 'EPC & O&M aus einer Hand',
          detail: 'Keine Subgewerke-Lücken',
        },
      ],
    };
  },
};
</script>
